import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import RefreshBanner from 'components/RefreshBanner';
import {OffersActions, RefreshOffersAction} from 'store/offers/offers.reducer';
import {hasNewOffersSelector} from 'store/offers/offers.selectors';

const ConnectedRefreshBanner: React.FC = () => {
  const dispatch = useDispatch();
  const hasNewOffers = useSelector(hasNewOffersSelector);
  const onRefreshOffers = useCallback(
    () => dispatch(OffersActions.refreshOffers(RefreshOffersAction.refresh)),
    [dispatch]
  );
  const onDissmissOffers = useCallback(
    () => dispatch(OffersActions.refreshOffers(RefreshOffersAction.dismiss)),
    [dispatch]
  );

  if (!hasNewOffers) {
    return null;
  }

  return (
    <RefreshBanner
      onRefreshOffersPress={onRefreshOffers}
      onDismissPress={onDissmissOffers}
    />
  );
};

export default ConnectedRefreshBanner;
